// src/theme.ts
import { useSelector } from 'react-redux';
import { extendTheme } from '@chakra-ui/react';
import { TState } from './redux/store';

export const theme = {
  none: '#ffffff',
  main: '#3d3d3e',
  mainBis: '#ffffff',
  secondary: '#8f9bba',
  btnBg: '#f5f7ff',
  lighter: '#f0f6ff',
  // light: 'blue.200',
  light: '#cbddfd',
  // normal: 'blue.400',
  normal: '#8ab4f9',
  // dark: '#2865eb',
  dark: '#4a8bf4',
  darker: 'blue.800',
  // navBg: '#1c2969',
  // navBg: '#2d57b5',
  navBg: '#fff',
  navColor: 'blue.500',
  fontSize: {
    XXL: '40px',
    headerBig: '34px',
    header: '24px',
    bigger: '20px',
    big: '18px',
    normal: '16px',
    small: '14px',
    table: '13px',
    xSmall: '11px',
    xxSmall: '8px',
  },
  margin: ['10px', '16px'],
};

const useExTheme = () => {
  const themeState = useSelector((state: TState) => state.theme);

  return extendTheme({
    components: {
      Input: {
        baseStyle: {
          field: {
            border: '1px solid #d1d5db',
            height: '33px',
            lineHeight: '33px',
            _disabled: {
              color: '#999999',
              backgroundColor: '#f2f2f2 !important',
              opacity: 1,
            },
          },
        },
      },
      Tooltip: {
        variants: {
          form: {
            top: '-43px',
            w: '1000px',
          },
        },
      },
      Switch: {
        baseStyle: {
          track: {
            _checked: {
              bg: themeState.dark,
            },
          },
        },
      },
      Select: {
        baseStyle: {
          field: {
            _disabled: {
              color: '#999999',
              backgroundColor: '#f2f2f2 !important',
              opacity: 1,
            },
            height: '33px',
            lineHeight: '33px',
          },
        },
      },
      Tabs: {
        parts: ['root', 'tablist', 'tab', 'tabpanel', 'tabpanels'],
        baseStyle: {
          root: {
            borderRadius: '3px',
            color: themeState.main,
          },
          tab: {
            gap: 0.5,
            cursor: 'pointer',
            border: 'none',
            borderTop: 'none',
            borderX: 'none',
            borderBottom: '4px solid',
            _hover: {
              color: themeState.dark,
              borderColor: 'gray.400',
            },
            _selected: {
              color: themeState.dark,
              borderColor: 'gray.800 !important',
            },
            'padding-inline-start': '7px !important',
            'padding-inline-end': '7px !important',
            marginBottom: '0px',
          },
          tablist: {
            position: 'relative',
            gap: 1,
            borderWidth: '0 !important',
            // boxShadow: 'lg',
            // zIndex: 1,
            marginBottom: '2px',
          },
          tabpanels: {
            position: 'relative',
            // bgColor: '#f9fafb',
            // zIndex: 0,
          },
        },
      },
      Textarea: {
        baseStyle: {
          _disabled: {
            color: '#999999',
            backgroundColor: '#f2f2f2 !important',
            opacity: 1,
          },
        },
      },
      Button: {
        baseStyle: {
          // borderRadius: '16px',
          // boxShadow: '45px 76px 113px 7px rgba(112, 144, 176, 0.08)',
          // transition: '.25s all ease',
          // boxSizing: 'border-box',
          // _focus: {
          //   boxShadow: 'none',
          // },
          // _active: {
          //   boxShadow: 'none',
          // },
        },
      },
    },
    styles: {
      global: {
        // '.container': {
        //   boxShadow: 'rgba(0, 0, 0, 0.25) 0px 25px 50px -12px',
        // },
        // 'html, body': {
        //   'font-size': '13.2px !important',
        // },
        // 'table tr th, table tr td': {
        //   'font-size': '11.2px !important',
        // },
        // '.chakra-badge': {
        //   'font-size': '10.2px !important',
        // },
        // 'header, h2': { 'font-size': '20px !important' },
      },
    },
    fonts: {
      body: `'Roboto Condensed', sans-serif`,
      heading: `'Roboto Condensed', sans-serif`,
    },
  });
};

export const colorList = [
  'red',
  'orange',
  'yellow',
  'green',
  'teal',
  'blue',
  'cyan',
  'purple',
  'pink',
  'gray',
];

export const colors = {
  main: colorList[5],
};

export default useExTheme;
